import { Me } from "../types/Me";
import { API_BASE_URL, testSessionId } from "./api";

export const getMe = async (sessionId: string): Promise<Me> => {
  const response = await fetch(`${API_BASE_URL}/accounts/me`, {
    headers: {
      Authorization: `Bearer ${sessionId}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch user data");
  }
  const data = await response.json();
  return data;
};

// Example usage with testSessionId
export const getMyProfile = () => getMe(testSessionId);
